module.exports = __webpack_public_path__ + "img/c00_buildingtechtwomansaw_Normal_ua.7313d5bb.webp";